import { getDesignsImageUrl } from 'helpers/imageUrl';

const useImageUrl =
  () =>
  ({ img, width, height }) =>
    getDesignsImageUrl(img, width, height);

export default useImageUrl;
